module.exports = __webpack_public_path__ + "static/epitome-xiao-banner-dd4bccb81e5d543d6a86f3137c6ba160.png";